
import './AnalyticsPage.css';

interface AnalyticsPageViewProps {
  loading: boolean;
  error: string | null;
  dashboard: any | null;
  payments: any | null;
  subscriptions: any | null;
  revenue: any | null;
  apiKeyMissing?: boolean;
}

const DataDisplay = ({ data }: { data: any }) => {
  if (!data) return null;
  return (
    <ul className="data-display-list">
      {Object.entries(data).map(([key, value]) => (
        <li key={key} className="data-display-item">
          <span className="data-display-key">{key.replace(/([A-Z])/g, ' $1')}</span>
          <span>{String(value)}</span>
        </li>
      ))}
    </ul>
  );
};

function AnalyticsPageView({ loading, error, dashboard, payments, subscriptions, revenue, apiKeyMissing }: AnalyticsPageViewProps) {
  if (loading) return <main className="analytics-loading" role="status" aria-live="polite">Loading analytics…</main>;
  if (error) return <main className="analytics-error" role="alert" aria-live="polite">Error: {error}</main>;

  return (
    <main className="analytics-container">
      {apiKeyMissing && (
        <div className="admin-api-key-warning">
          Analytics routes require an API key. Set VITE_QreditCharge_API_KEY or localStorage.QreditCharge_API_KEY and refresh.
        </div>
      )}
      <h1 className="analytics-header">Analytics</h1>

      <div className="analytics-card">
        <h2 className="analytics-section-header">Dashboard</h2>
        <DataDisplay data={dashboard} />
      </div>

      <div className="analytics-card">
        <h2 className="analytics-section-header">Payments</h2>
        <DataDisplay data={payments} />
      </div>

      <div className="analytics-card">
        <h2 className="analytics-section-header">Subscriptions</h2>
        <DataDisplay data={subscriptions} />
      </div>

      <div className="analytics-card">
        <h2 className="analytics-section-header">Revenue</h2>
        <DataDisplay data={revenue} />
      </div>
    </main>
  );
}

export default AnalyticsPageView;
